import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=66319510&"
import script from "./LinkItem.vue?vue&type=script&lang=js&"
export * from "./LinkItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinkItem.vue"
export default component.exports